import { TintChip } from "./TintChip";
import { TINT } from "../lib/moduleColors";

// Tuile de statistique de l'accueil — « style B » (2026-09-28, maquette
// approuvée par l'utilisateur après 2 passes d'itération). Remplace
// l'ancien chip rond plein blanc par un chip teinté tenu par le label, un
// fond à lumière radiale + grain, et un pied de carte à séparateur fin
// pour une 2e donnée + une action explicite (au lieu de rendre toute la
// tuile cliquable — un lien imbriqué dans un `<button>` n'est pas valide
// en HTML, et l'action explicite est plus lisible qu'un tap dans le vide).
//
//   value / valueSuffix : nombre principal, en 2 tailles façon appli
//     financière (valueSuffix optionnel — ex. ",83 €" pour "1 098").
//   footerMeta : texte/nœud à gauche du pied de carte (ex. "171 collections
//     suivies"). footerLabel/onClick : lien d'action à droite (ex. "Voir").
//   children : contenu additionnel entre le sous-texte et le pied (ex. les
//     vignettes de « Recherchées »).
export const StatWidget = ({
  icon: Icon, label, value, valueSuffix, subtext, color,
  footerMeta, footerLabel, onClick, compact = false, children,
}) => {
  const tint = TINT[color] || "113 113 122";
  return (
    <div className={`tcard ${compact ? "p-4" : "p-5"}`}>
      <div className="tglow" style={{ background: `radial-gradient(120px 100px at 88% -10%, rgb(${tint} / .35), transparent 70%)` }} />
      <div className="tgrain" />
      <div className="thead mb-3">
        <TintChip icon={Icon} color={color} />
        <span className="tlabel">{label}</span>
      </div>
      <div className="tnum-row">
        <span className="tnum-big stat-value">{value}</span>
        {valueSuffix && <span className="tnum-small stat-value">{valueSuffix}</span>}
      </div>
      {subtext && <div className="tsub">{subtext}</div>}
      {children}
      {(footerMeta || footerLabel) && (
        <div className="tfoot">
          <span className="tfoot-meta">{footerMeta}</span>
          {footerLabel && (
            <button className="tlink" style={{ color: `rgb(${tint})` }} onClick={onClick}>
              {footerLabel}
              <svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
            </button>
          )}
        </div>
      )}
    </div>
  );
};
